export default __webpack_public_path__ + "static/media/slide-campain2.1630c2c7.png";